export default __webpack_public_path__ + "static/media/profileImg2.c1523807.png";